import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Paths from "@/constants/paths";
import { CustomCotationsTypeSelection } from "@/components/customCotations/customCotationsTypeSelection";
import { CustomCotationsOther } from "@/components/customCotations/customCotationsOther";
import { CustomCotationsParcelPallet } from "@/components/customCotations/customCotationsParcelPallet";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useGetCompany } from "@/api/company.api";
import { useGetCustomsV1 } from "@/api/customs.api";

export const CustomCotationsPage = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const navigate = useNavigate();

  const { data: company, isPending: isCompanyPending, isError: isErrorCompany } = useGetCompany();
  const {
    data: customs,
    isPending: isPendingCustoms,
    isError: isErrorCustoms,
  } = useGetCustomsV1("customQuotation");

  const isLoading = isCompanyPending || isPendingCustoms;
  const isError = isErrorCompany || isErrorCustoms;

  if (isLoading) {
    return (
      <div className="flex h-fit min-h-screen w-full flex-1 flex-col gap-8 p-8">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <button
              className="text-brand700 hover:text-brand600 flex h-fit w-fit flex-row items-center gap-2 bg-transparent font-semibold"
              onClick={() => navigate(Paths.home.cotations)}
            >
              <ArrowLeft width={20} height={20} />
              <p>Retour à la cotation</p>
            </button>
            <h1 className="font-jakarta-sans text-3xl font-semibold">Demandes spécifiques</h1>
          </div>
        </div>
        <div className="flex h-full w-full items-center justify-center">
          <Loader2 className="h-10 w-10 animate-spin" />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex h-fit min-h-screen w-full flex-1 flex-col gap-8 p-8">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <button
              className="text-brand700 hover:text-brand600 flex h-fit w-fit flex-row items-center gap-2 bg-transparent font-semibold"
              onClick={() => navigate(Paths.home.cotations)}
            >
              <ArrowLeft width={20} height={20} />
              <p>Retour à la cotation</p>
            </button>
            <h1 className="font-jakarta-sans text-3xl font-semibold">Demandes spécifiques</h1>
          </div>
        </div>
        <div className="flex h-full w-full items-center justify-center">
          <p>Erreur lors du chargement de la demande spécifique</p>
        </div>
      </div>
    );
  }

  const displayTab = () => {
    switch (activeTab) {
      case 0:
        return <CustomCotationsTypeSelection setActiveTab={setActiveTab} />;
      case 1:
        return (
          <CustomCotationsParcelPallet activeTab={activeTab} company={company} customs={customs} />
        );
      case 2:
        return (
          <CustomCotationsParcelPallet activeTab={activeTab} company={company} customs={customs} />
        );
      case 3:
        return <CustomCotationsOther company={company} customs={customs} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex h-fit min-h-screen w-full flex-1 flex-col gap-8 p-8">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <button
            className="text-brand700 hover:text-brand600 flex h-fit w-fit flex-row items-center gap-2 bg-transparent font-semibold"
            onClick={() => navigate(Paths.home.cotations)}
          >
            <ArrowLeft width={20} height={20} />
            <p>Retour à la cotation</p>
          </button>
          <h1 className="font-jakarta-sans text-3xl font-semibold">Demandes spécifiques</h1>
          <p className={`${activeTab === 0 ? "block" : "hidden"}`}>
            Sélectionnez le type de demande
          </p>
        </div>
      </div>
      {displayTab()}
    </div>
  );
};
